import { Link, useParams } from 'react-router-dom';
import { Utensils } from 'lucide-react';
import { useTableContext } from './useTableContext';

/**
 * Landing tab — light welcome screen with a single primary CTA into
 * the menu. Most flows in the reference shop start at Menu; we keep
 * Home as a courtesy landing in case the QR is opened far ahead of
 * the customer actually wanting to order.
 */
export default function DineHome() {
  const { tenantCode = '', qrToken = '' } = useParams<{ tenantCode: string; qrToken: string }>();
  const { table } = useTableContext();

  return (
    <div className="flex flex-col items-center px-6 pt-12 text-center">
      <div className="grid h-20 w-20 place-items-center rounded-2xl bg-primary-light text-primary">
        <Utensils size={32} />
      </div>
      <h1 className="mt-4 text-xl font-semibold text-content-primary">
        Welcome to {table?.tenantName ?? 'our restaurant'}
      </h1>
      <p className="mt-2 max-w-sm text-sm text-content-muted">
        You’re ordering for{' '}
        <span className="font-medium text-content-secondary">{table?.tableCode ?? table?.tableName ?? 'your table'}</span>.
        Browse the menu and tap <span className="font-semibold text-primary">+ Add</span> to
        build your order.
      </p>
      <Link
        to={`/dine/${tenantCode}/t/${qrToken}/menu`}
        className="mt-6 inline-flex h-12 items-center rounded-md bg-primary px-6 text-sm font-semibold text-primary-foreground"
      >
        Browse Menu
      </Link>
    </div>
  );
}
